var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keyboard_double_arrow_right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.521 21L22.166 19.355L16.8227 14L22.166 8.645L20.521 7L13.521 14L20.521 21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8327 21L14.4777 19.355L9.13435 14L14.4777 8.645L12.8327 7L5.83268 14L12.8327 21Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowLeft);
export default __webpack_public_path__ + "static/media/double-arrow-left.5971f98e9858c388e7dd4a8d8ffb952b.svg";
export { ForwardRef as ReactComponent };